import { z } from "zod"

export const OrderIdSchema = z.uuid().meta({ id: "OrderId" })

export const PatientIdSchema = z.uuid().meta({ id: "PatientId" })

export const PaymentIdSchema = z.uuid().meta({ id: "PaymentId" })

export const ProductIdSchema = z.uuid().meta({ id: "ProductId" })

export const ProductVariantIdSchema = z.uuid().meta({ id: "ProductVariantId" })

export const ProductVariantSkuIdSchema = z.uuid().meta({ id: "ProductVariantSkuId" })

export const CheckoutOfferingIdSchema = z.uuid().meta({ id: "CheckoutOfferingId" })

export const VisitFeeRuleIdSchema = z.uuid().meta({ id: "VisitFeeRuleId" })

export const AddressIdSchema = z.uuid().meta({ id: "AddressId" })

export const MembershipEnrollmentIdSchema = z.uuid().meta({ id: "MembershipEnrollmentId" })

export const MembershipCycleIdSchema = z.uuid().meta({ id: "MembershipCycleId" })
